import classNames from "classnames";
import { useId, useRef } from "react";

// Material UI Switch Design in Tailwind inspired by:
// https://www.material-tailwind.com/docs/react/switch#switch
// https://github.com/creativetimofficial/material-tailwind/blob/5fca58a67da2ebff00662b7b4ebc931735240b13/packages/material-tailwind-react/src/components/Switch/index.tsx
// https://github.com/creativetimofficial/material-tailwind/blob/5fca58a67da2ebff00662b7b4ebc931735240b13/packages/material-tailwind-react/src/theme/components/switch/index.ts

export const Switch = (
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > & {
    label?: string;
  },
) => {
  const { className, id: _id, type: _type, label = "", ...restProps } = props;
  const generatedId = useId();
  const id = _id || generatedId;
  const switchRef = useRef<HTMLInputElement>(null);

  const onKeyUp = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLLabelElement>,
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      switchRef.current?.click();
    }
  };

  return (
    <div className="m:flex m:h-[18px] m:items-center m:gap-3">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <label
        htmlFor="animated-weather-icon"
        className="m:text-base m:leading-[15px] m:font-medium m:tracking-0.4 m:antialiased"
        onKeyUp={onKeyUp}>
        {label}
      </label>

      <div className="m:relative m:inline-block m:h-4 m:w-8 m:cursor-pointer m:rounded-full">
        <input
          type="checkbox"
          id={id}
          className={classNames(
            "m:peer/switch m:absolute m:h-4 m:w-8 m:cursor-pointer m:appearance-none m:rounded-full m:bg-special-switch-track m:transition-colors m:duration-300 m:peer-checked/switch:border-blue-400 m:peer-checked/switch:before:bg-blue-400 m:checked:bg-blue-400",
            className,
          )}
          ref={switchRef}
          onKeyUp={onKeyUp}
          {...restProps}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          htmlFor={id}
          className="m:before:content[''] m:absolute m:top-2/4 m:-left-1 m:h-5 m:w-5 m:-translate-y-2/4 m:cursor-pointer m:rounded-full m:border m:border-solid m:border-special-switch-knob m:bg-special-switch-knob m:shadow-switch-knob m:transition-all m:duration-300 m:peer-checked/switch:translate-x-full m:peer-checked/switch:border-blue-200 m:peer-checked/switch:bg-blue-200 m:before:absolute m:before:top-2/4 m:before:left-2/4 m:before:block m:before:h-10 m:before:w-10 m:before:-translate-x-2/4 m:before:-translate-y-2/4 m:before:rounded-full m:before:bg-blue-400 m:before:opacity-0 m:before:transition-opacity m:hover:before:opacity-10">
          <div className="m:relative m:top-2/4 m:left-2/4 m:inline-block m:-translate-x-2/4 m:-translate-y-2/4 m:overflow-hidden m:rounded-full m:p-5"></div>
        </label>
      </div>
    </div>
  );
};
